import * as React from 'react';
import { Card as BaseCard } from '@mc/react-core';
import * as Classes from '../Classes';
import classNames from 'classnames';

type Props = Omit<React.ComponentProps<typeof BaseCard> & {}, 'elevation'>;

export class Card extends React.PureComponent<Props> {
  render() {
    const { className, ...other } = this.props;
    let cls = classNames(Classes.UI_CARD, className && className);

    return <BaseCard className={cls} {...other} />;
  }
}
